var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserFilledBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#F6E7F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 16,
    fill: "#F6E7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6364 19.0909C27.6364 21.3466 25.8012 23.1818 23.5455 23.1818C21.2897 23.1818 19.4545 21.3466 19.4545 19.0909C19.4545 16.8352 21.2897 15 23.5455 15C25.8012 15 27.6364 16.8352 27.6364 19.0909ZM30.0909 31.3636V28.3642C30.0909 25.9579 27.8892 24 25.1818 24H21.9091C19.2017 24 17 25.9579 17 28.3642V31.3636V32.1818V33H30.0909V32.1818V31.3636Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserFilledBig);
export default __webpack_public_path__ + "static/media/icon-user-filled-big.4122cc3b5f750423296df5d5db07ee17.svg";
export { ForwardRef as ReactComponent };